export default __webpack_public_path__ + "static/media/loader.a2813e38.svg";